function printAppointmentRange(momentTime) {
    var rangeStart = momentTime.clone().startOf('day');
    var rangeEnd = momentTime.clone().add(1, 'days').startOf('day');
    return {
        start: rangeStart.format(),
        end: rangeEnd.format()
    }
}

function openWindow(url) {
    window.open(url, '_blank')
}

if (typeof exports !== "undefined") {
    exports.printAppointmentRange = printAppointmentRange;
    exports.openWindow = openWindow
}
